/**
 * Split Bill Modal Component - Using new Modal component
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalTitle,
} from '../../components/ui/modal';
import { Button } from '../../components/ui/button';
import { Minus, Plus, Split } from 'lucide-react';

export function SplitBillModal({
  open,
  onOpenChange,
  total,
  splitCount,
  setSplitCount,
  formatCurrency,
  onSplit,
}) {
  const { t } = useTranslation();

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalContent size="sm">
        <ModalHeader>
          <ModalTitle className="flex items-center gap-2">
            <Split className="h-5 w-5" />
            Dividir Conta
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          <div className="text-center">
            <p className="text-sm text-muted-foreground mb-2">Dividir em quantas partes?</p>
            <div className="flex items-center justify-center gap-4">
              <Button
                variant="outline"
                size="icon"
                onClick={() => setSplitCount(Math.max(2, splitCount - 1))}
              >
                <Minus className="h-4 w-4" />
              </Button>
              <span className="text-3xl font-bold font-mono w-12">{splitCount}</span>
              <Button
                variant="outline"
                size="icon"
                onClick={() => setSplitCount(splitCount + 1)}
              >
                <Plus className="h-4 w-4" />
              </Button>
            </div>
            <p className="text-lg font-mono font-bold mt-4">
              {formatCurrency(total / splitCount)} cada
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>{t('common.cancel')}</Button>
          <Button onClick={onSplit}>Dividir</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default SplitBillModal;
